/**
 * The layer of the upsell modals. The asset viewer sits at 1060, above the Bootstrap modal layer
 * (1055); the choice (design a2) and the offer (b4) open from inside the viewer, so they go above it.
 */
export const UPSELL_MODAL_Z_INDEX = 1070;
